import { object, string, array } from "yup";
import { ProjectSearchFormKey } from "./Models";
import { INPUT_LIMIT } from "../../../helpers/constants";
import { KeyValue } from "../../../helpers/types/common";
import { specialCharactersNotAllowedValidationForOptionalField } from "../../../helpers/constants/commonValidationSchemaUtils";

export const projectSearchFormSchema = (commonValidationMessages: KeyValue) => {
  return object().shape({
    [ProjectSearchFormKey.projectName]: 
      specialCharactersNotAllowedValidationForOptionalField(
          commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProjectSearchFormKey.projectNameFilter]: string().default(""),
    [ProjectSearchFormKey.projectKey]: 
      specialCharactersNotAllowedValidationForOptionalField(
          commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProjectSearchFormKey.projectKeyFilter]: string().default(""),
    [ProjectSearchFormKey.clientName]: 
      specialCharactersNotAllowedValidationForOptionalField(
          commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProjectSearchFormKey.clientNameFilter]: string().default(""),
    [ProjectSearchFormKey.clientCode]: 
      specialCharactersNotAllowedValidationForOptionalField(
          commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProjectSearchFormKey.clientCodeFilter]: string().default(""),
    [ProjectSearchFormKey.productLines]: array().default([]),
    [ProjectSearchFormKey.productManagers]: array().default([]),
    [ProjectSearchFormKey.projectStatus]: string().default(""),
    [ProjectSearchFormKey.participantName]: 
      specialCharactersNotAllowedValidationForOptionalField(
          commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ProjectSearchFormKey.participantNameFilter]: string().default(""),
  });
};
